const intro = document.getElementById('site-intro');

if (intro && document.documentElement.classList.contains('site-intro-active')) {
    let removed = false;
    const remove = () => {
        if (removed) return;
        removed = true;
        intro.remove();
        document.documentElement.classList.remove('site-intro-active');
        document.documentElement.classList.add('site-intro-seen');
        document.dispatchEvent(new Event('jk:intro-complete'));
    };

    intro.addEventListener('animationend', e => {
        if (e.target === intro) remove();
    });
    // Covers background tabs and browsers that suppress CSS animation events.
    setTimeout(remove, 1600);
} else {
    intro?.remove();
}
